import { render } from "./MTab.vue?vue&type=template&id=2505fd8b"
import script from "./MTab.vue?vue&type=script&lang=js"
export * from "./MTab.vue?vue&type=script&lang=js"

import "./MTab.vue?vue&type=style&index=0&id=2505fd8b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__